import { NgModule } from '@angular/core';
import { RilyLibCalculatorV8Component } from './rily-lib-calculator-v8.component';



@NgModule({
  declarations: [RilyLibCalculatorV8Component],
  imports: [
  ],
  exports: [RilyLibCalculatorV8Component]
})
export class RilyLibCalculatorV8Module { }
